import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import ClientManagerService from '../services/ClientManager/clientManager.service';
import type { AddOnCatalogueItem } from '../types/ClientManagementTypes';

export const useAddOns = () => {
  const { getAddOns } = ClientManagerService();
  const { data, isLoading, isLoadingError } = useQuery(getAddOns());

  // Memoised because the picker's option list and the rows both derive from these.
  const addOns = useMemo(() => data ?? [], [data]);

  // Keyed lookup: every add-on row resolves its own catalogue entry by id.
  const addOnsById = useMemo(() => new Map<number, AddOnCatalogueItem>(addOns.map((addOn) => [addOn.id, addOn])), [addOns]);

  return {
    addOns,
    addOnsById,
    isLoadingAddOns: isLoading,
    isAddOnsLoadingError: isLoadingError,
  };
};
